<template>
    <NodeViewWrapper
        class="columns"
        @click.stop="builder.focusedJsonId = node.attrs.id"
        :style="{
            marginTop: theme.marginTop,
            marginBottom: theme.marginBottom,
        }"
        :class="{
            'two-column-equal': theme.layout === 'two-column-equal',
            'left-two-thirds': theme.layout === 'left-two-thirds',
            'right-two-thirds': theme.layout === 'right-two-thirds',
            'left-sixty-forty': theme.layout === 'left-sixty-forty',
            'right-sixty-forty': theme.layout === 'right-sixty-forty',
        }"
    >
        <NodeViewContent :style="{ 
            gap: `${props.node.attrs.gap}px`,
            '--background-color': theme.backgroundColor,
            '--padding-top': theme.paddingTop,
            '--padding-bottom': theme.paddingBottom,
            '--padding-left': theme.paddingLeft,
            '--padding-right': theme.paddingRight,
        }" />
    </NodeViewWrapper>
</template>

<script lang="ts" setup>
import { nodeViewProps, NodeViewWrapper, NodeViewContent } from "@tiptap/vue-3";
import { createColumnsBlock } from "~/stores/mail-block-editor/defaults";

const props = defineProps(nodeViewProps);
const builder = useMailStore();
const theme = computed(() => {
    const theme = createColumnsBlock();

    return builder.fieldCollection.replaceContent({
        layout: props.node.attrs.layout ?? theme?.layout,
        marginBottom: props.node.attrs.marginBottom ?? theme?.marginBottom,
        marginTop: props.node.attrs.marginTop ?? theme?.marginTop,
        backgroundColor: props.node.attrs.backgroundColor ?? theme?.backgroundColor,
        paddingTop: props.node.attrs.paddingTop ?? theme?.paddingTop,
        paddingBottom: props.node.attrs.paddingBottom ?? theme?.paddingBottom,
        paddingLeft: props.node.attrs.paddingLeft ?? theme?.paddingLeft,
        paddingRight: props.node.attrs.paddingRight ?? theme?.paddingRight,
    });
});
</script>

<style scoped>
.columns {
    & > div {
        width: 100%;
        display: grid;
        grid-auto-flow: column;

        & > :deep(.column) {
            overflow: auto;
            background-color: var(--background-color);
            padding-top: var(--padding-top);
            padding-bottom: var(--padding-bottom);
            padding-left: var(--padding-left);
            padding-right: var(--padding-right);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
        }
    }

    &.two-column-equal > div {
        grid-auto-columns: 1fr;
    }

    &.left-two-thirds > div {
        grid-auto-columns: 2fr 1fr;
    }

    &.right-two-thirds > div {
        grid-auto-columns: 1fr 2fr;
    }

    &.left-sixty-forty > div {
        grid-auto-columns: 6fr 4fr;
    }

    &.right-sixty-forty > div {
        grid-auto-columns: 4fr 6fr;
    }
}
</style>
